<template lang="pug">
  .login
    img(src="@/assets/logo.png", @click="doLogin")
    v-btn(
      class="ma-2"
      depressed
      :loading="loading"
      :disabled="loading"
      @click="doLogin"
    )
      v-icon(left) email
      | Login with email
      div(ref="signin")
</template>

<script>
import auth from '@/services/auth'

export default {
  data () {
    return {
      loading: false
    }
  },
  async mounted () {
  },
  methods: {
    async doLogin () {
      try {
        this.loading = true
        const user = await auth.signIn()
        this.$store.dispatch('user/signIn', user)
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.login
  display: flex
  flex-direction: column
  height: 100vh
  justify-content: center
  align-items: center

  >>> .mdl-spinner.firebaseui-busy-indicator
    width: 30px
    height: 30px
    top: auto
</style>
